import React, { useCallback, useRef, useState, useEffect } from 'react';
import Moveable from 'react-moveable';
import { getPageNoAdditionalContent } from './pageNumberHelper';
import useClickOutsideHandler from '../../HandleClickOutside';
import { dummyCallback } from '../../../../utils/complexDocumentConstants';
import {
  COMPLEX_DOCUMENT_CONTEXT_KEYS,
  useDocumentContext,
} from '../../../../context/complexDocumentContext';
import { CONTEXT_KEYS, useArtboardContext } from '../../../../context/complexArtboardContext';

export const PageNumberRenderer = ({ element, parentUUID, pageRef, methods, ...props }) => {
  const { docPageNumber, isPreview, pageId, editable } = props;

  const contextSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.STYLES], []);
  const [DocumentStyles] = useDocumentContext(contextSelector);

  const { pageNumberType, ofText } = docPageNumber;
  const { contents } = docPageNumber.contents;
  const  style  = DocumentStyles?.pageNumber?.contents?.style;
  const moveableRef = useRef();
  const containerRef = useRef();
  const pageNoRef = useRef();
  
  const currentFontFamily = contents[0]?.style?.fontFamily ? contents[0]?.style?.fontFamily :  DocumentStyles?.fontFamily ;
  const currentFontSize = contents[0]?.style?.fontSize ? contents[0]?.style?.fontSize :  DocumentStyles?.fontSize ;
  const [elementStyle, setElementStyle] = useState({
    ...contents[0].style,
    whiteSpace: 'nowrap',
    fontFamily: currentFontFamily,
    fontSize: currentFontSize
  });

  const [isSelected, setIsSelected] = useState(false);
  useClickOutsideHandler({
    ref: containerRef,
    clickInsideHandler: dummyCallback,
    clickOutsideHandler: () => setIsSelected(false),
  });

  useEffect(()=>{
     setElementStyle(prev => ({
           ...contents[0].style,
           whiteSpace: 'nowrap',
          fontFamily: currentFontFamily, fontSize: currentFontSize
        }));
  },[docPageNumber])

    useEffect(() => {
      const handleFontStyleUpdate = e => {
        
        const { newFontFamilyOrSize, styleType } = e.detail;
        if(styleType === 'fontFamily'){
          if(contents[0].style?.fontFamily){
            return;
          }
          else{
             setElementStyle(prev => ({
          ...prev,
          fontFamily: newFontFamilyOrSize,
        }));
          }
        }
        else if(styleType === 'fontSize'){
          const currentFontSize =  contents[0]?.style?.fontSize ? contents[0]?.style?.fontSize : newFontFamilyOrSize ;
          if(contents[0].style?.fontSize){
            return;
          }
          else{
            setElementStyle(prev => ({
          ...prev,
          fontSize: currentFontSize,
        }));
      }
        }
      };
      document.addEventListener('textElementFontStyleUpdate', handleFontStyleUpdate);
      return () => {
        document.removeEventListener('textElementFontStyleUpdate', handleFontStyleUpdate);
      };
    }, [docPageNumber]);

  const customSelector = useCallback(
    state => {
      if (isPreview) {
        const allFlowIds = state[COMPLEX_DOCUMENT_CONTEXT_KEYS.FLOWS];
        let allPages = [];
        allFlowIds.forEach(flowId => (allPages = [...allPages, ...state[flowId]['pages']]));
        const pageIndex = allPages.findIndex(id => id === pageId);
        return [pageIndex + 1, allPages.length];
      }
      return [undefined, undefined];
    },
    [isPreview, pageId],
  );
  const [[currentNo, totalPages]] = useDocumentContext(customSelector);

  const interactiveDesignSelector = useCallback(store => store[CONTEXT_KEYS.IS_INTERACTIVE_DESIGN], []);
  const [isInteractiveDesign] = useArtboardContext(interactiveDesignSelector, `ComplexDocumentName`);

  const containerStyle = {
    ...style,
    ...{
      position: 'absolute',
      zIndex: 3,
      transform: `translateX(${style.x}px) translateY(${style.y}px) rotate(${style.rotate}deg)`,
      width: `${contents[0].style.width}px`,
      height: `${contents[0].style.height}px`,
      background: style.backgroundColor,
      x: undefined,
      y: undefined,
      fontFamily: docPageNumber?.contents?.style?.fontFamily,
      fontSize: docPageNumber?.contents?.style?.fontSize
    },
  };


  const additionalContent = getPageNoAdditionalContent(
    pageNumberType,
    ofText,
    currentNo,
    totalPages,
  );

  return (
    <div onBlur={() => setIsSelected(false)} ref={containerRef}>
      <span
        style={containerStyle}
        ref={pageNoRef}
        onClick={() => {
          if(editable && !isInteractiveDesign)
          setIsSelected(true);
        }}
      >
        <span style={elementStyle}>
          {contents[0].content}
          {additionalContent}
        </span>
      </span>
      <Moveable
        ref={moveableRef}
        origin={false}
        edgeDraggable={true}
        originDraggable={false}
        target={isSelected ? pageNoRef.current : null}
        container={pageRef.current}
        draggable
        dragArea={true}
        onDrag={({ transform }) => {
          pageNoRef.current.style.transform = transform;
        }}
        onDragEnd={e => {
          requestAnimationFrame(() => {
            const rect = e.moveable.getRect();
            methods.updatePageNumber({
              uuid: parentUUID,
              style: { x: rect.left, y: rect.top },
              historyChange: {},
            });
          });
        }}
      />
    </div>
  );
};
